/**
 * Les Parisiennes — Search Module
 */
(function () {
  'use strict';
  var LP = window.LPTheme || {};
  var escapeHtml = LP.escapeHtml || function (str) { var d = document.createElement('div'); d.textContent = str; return d.innerHTML; };

  var activateFocusTrap = LP.activateFocusTrap || function () {};
  var deactivateFocusTrap = LP.deactivateFocusTrap || function () {};

  function registerInit(name, fn) {
    if (LP && typeof LP.registerInit === 'function') LP.registerInit(name, fn);
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ============================================================
	   * 5. SEARCH OVERLAY
	   * ============================================================ */
  window.toggleSearch = function () {
    var overlay = document.getElementById('search-overlay');
    if (!overlay) return;
    var isOpen = overlay.classList.contains('is-open');
    if (!isOpen) overlay.hidden = false;
    overlay.classList.toggle('is-open', !isOpen);
    document.body.style.overflow = isOpen ? '' : 'hidden';
    overlay.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    if (!isOpen) {
      var input = overlay.querySelector('.search-overlay__input');
      activateFocusTrap(overlay, input);
    } else {
      deactivateFocusTrap(overlay);
      // Clear results when closing
      var results = document.getElementById('predictive-results');
      var closedInput = overlay.querySelector('[data-predictive-search-input]');
      if (closedInput && closedInput.__lpPredictiveCancel) closedInput.__lpPredictiveCancel();
      else if (results) results.innerHTML = '';
      window.setTimeout(function () {
        if (!overlay.classList.contains('is-open')) overlay.hidden = true;
      }, 400);
    }
  };

  /* ============================================================
   * 5b. PREDICTIVE SEARCH
   * ============================================================ */
  function initPredictiveSearch() {
    document.querySelectorAll('[data-predictive-search]').forEach(function (scope) {
      bindPredictiveSearch(
        scope.querySelector('[data-predictive-search-input]'),
        scope.querySelector('[data-predictive-search-results]'),
        scope
      );
    });
  }

  function bindPredictiveSearch(input, resultsContainer, scope) {
    if (!input || !resultsContainer || input.__lpPredictiveBound) return;
    input.__lpPredictiveBound = true;
    var configuredTypes = scope.getAttribute('data-search-types') || 'product,page,article';
    var typeList = configuredTypes.split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    var limitScope = scope.getAttribute('data-search-limit-scope') === 'all' ? 'all' : 'each';
    var unavailable = scope.getAttribute('data-search-unavailable') === 'show' ? 'show' : 'last';
    var includeCollections = typeList.indexOf('collection') !== -1;
    var includePages = typeList.indexOf('page') !== -1;
    var includeArticles = typeList.indexOf('article') !== -1;

    var debounceTimer;
    var abortController;
    var lastQuery = '';
    var requestVersion = 0;

    function cancelPredictiveSearch() {
      clearTimeout(debounceTimer);
      if (abortController) abortController.abort();
      requestVersion++;
      lastQuery = '';
      resultsContainer.innerHTML = '';
      resultsContainer.setAttribute('aria-busy', 'false');
    }
    input.__lpPredictiveCancel = cancelPredictiveSearch;

    function queuePredictiveSearch() {
      var query = input.value.trim();
      if (query === lastQuery) return;
      cancelPredictiveSearch();
      lastQuery = query;
      if (query.length < 2) return;
      var version = requestVersion;
      debounceTimer = setTimeout(function () {
        fetchPredictiveResults(query, version);
      }, 300);
    }
    input.addEventListener('input', queuePredictiveSearch);
    input.addEventListener('focus', queuePredictiveSearch);

    function fetchPredictiveResults(query, version) {
      abortController = new AbortController();
      resultsContainer.setAttribute('aria-busy', 'true');
      var searchingText = (window.lpThemeStrings && window.lpThemeStrings.predictiveSearching) || 'Searching…';
      resultsContainer.innerHTML = '<p class="search-overlay__status">' + escapeHtml(searchingText) + '</p>';
      var resourceTypes = encodeURIComponent(typeList.join(','));
      fetch(LP.route('search/suggest.json') + '?q=' + encodeURIComponent(query) + '&resources[type]=' + resourceTypes + '&resources[limit]=6&resources[limit_scope]=' + limitScope + '&resources[options][unavailable_products]=' + unavailable, {
        signal: abortController.signal
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Predictive search request failed');
          return r.json();
        })
        .then(function (data) {
          /* A changed query or detached section must not display an old response. */
          if (version !== requestVersion || input.isConnected === false) return;
          var results = data.resources && data.resources.results ? data.resources.results : {};
          renderPredictiveResults(
            results.products || [],
            includeCollections ? (results.collections || []) : [],
            includePages ? (results.pages || []) : [],
            includeArticles ? (results.articles || []) : [],
            query
          );
          resultsContainer.setAttribute('aria-busy', 'false');
        })
        .catch(function (err) {
          if (version !== requestVersion || input.isConnected === false) return;
          resultsContainer.setAttribute('aria-busy', 'false');
          if (err.name !== 'AbortError') {
            resultsContainer.innerHTML = '';
            lastQuery = '';
          }
        });
    }

    function renderPredictiveResults(products, collections, pages, articles, query) {
      var suggestions = includeCollections ? getSearchCategorySuggestions(query) : [];
      if (limitScope === 'all') suggestions = suggestions.slice(0, 2);
      if (!products.length && !collections.length && !pages.length && !articles.length && !suggestions.length) {
        var noResultsTitle = (window.lpThemeStrings && window.lpThemeStrings.searchNoResultsTitle) || 'No results found.';
        var noResultsHint = (window.lpThemeStrings && window.lpThemeStrings.searchNoResultsHint) || 'Try a different word or explore our collections.';
        var browseCollections = (window.lpThemeStrings && window.lpThemeStrings.searchBrowseCollections) || 'Explore collections';
        var collectionsUrl = (window.__lp_routes && window.__lp_routes.collections) || '/collections';
        resultsContainer.innerHTML = '<div class="search-overlay__empty"><p>' + escapeHtml(noResultsTitle) + '</p><span>' + escapeHtml(noResultsHint) + '</span><a href="' + encodeURI(collectionsUrl) + '" class="predictive-results__view-all">' + escapeHtml(browseCollections) + '</a></div>';
        return;
      }

      var html = '';
      var collectionsHeading = (window.lpThemeStrings && window.lpThemeStrings.predictiveCollectionsHeading) || 'Collections';
      var productsHeading = (window.lpThemeStrings && window.lpThemeStrings.predictiveProductsHeading) || 'Products';
      var pagesHeading = (window.lpThemeStrings && window.lpThemeStrings.predictivePagesHeading) || 'Pages';
      var viewAllLabel = (window.lpThemeStrings && window.lpThemeStrings.predictiveViewAll) || 'View all results';
      if (suggestions.length || collections.length) {
        html += '<p class="predictive-results__heading">' + escapeHtml(collectionsHeading) + '</p><div class="predictive-results__list predictive-results__list--compact">';
        suggestions.forEach(function (item) {
          html += '<a href="' + encodeURI(item.url) + '" class="predictive-results__item predictive-results__item--simple"><span class="predictive-results__title">' + escapeHtml(item.title) + '</span></a>';
        });
        collections.forEach(function (collection) {
          html += '<a href="' + encodeURI(collection.url) + '" class="predictive-results__item predictive-results__item--simple"><span class="predictive-results__title">' + escapeHtml(collection.title) + '</span></a>';
        });
        html += '</div>';
      }
      if (products.length) {
        html += '<p class="predictive-results__heading">' + escapeHtml(productsHeading) + '</p>';
        html += '<div class="predictive-results__list">';
        products.forEach(function (product) {
          var imgSrc = product.image ? product.image.replace(/\.([^.]+)$/, '_180x240.$1') : '';
          var price = product.price || '';
          html += '<a href="' + encodeURI(product.url) + '" class="predictive-results__item">';
          if (imgSrc) {
            html += '<img class="predictive-results__img" src="' + imgSrc + '" alt="' + escapeHtml(product.title) + '" width="60" height="80" loading="lazy" decoding="async">';
          } else {
            html += '<div class="predictive-results__img"></div>';
          }
          html += '<div class="predictive-results__info">';
          html += '<span class="predictive-results__title">' + escapeHtml(product.title) + '</span>';
          if (product.vendor) {
            html += '<span class="predictive-results__vendor">' + escapeHtml(product.vendor) + '</span>';
          }
          html += '</div>';
          html += '<span class="predictive-results__price">' + price + '</span>';
          html += '</a>';
        });
        html += '</div>';
      }
      if (pages.length) {
        html += '<p class="predictive-results__heading">' + escapeHtml(pagesHeading) + '</p><div class="predictive-results__list predictive-results__list--compact">';
        pages.forEach(function (page) {
          html += '<a href="' + encodeURI(page.url) + '" class="predictive-results__item predictive-results__item--simple"><span class="predictive-results__title">' + escapeHtml(page.title) + '</span></a>';
        });
        html += '</div>';
      }
      if (articles.length) {
        var articlesHeading = (window.lpThemeStrings && window.lpThemeStrings.predictiveArticlesHeading) || 'Articles';
        html += '<p class="predictive-results__heading">' + escapeHtml(articlesHeading) + '</p><div class="predictive-results__list predictive-results__list--compact">';
        articles.forEach(function (article) {
          html += '<a href="' + encodeURI(article.url) + '" class="predictive-results__item predictive-results__item--simple"><span class="predictive-results__title">' + escapeHtml(article.title) + '</span></a>';
        });
        html += '</div>';
      }
      var searchUrl = (window.__lp_routes && window.__lp_routes.search) || '/search';
      var viewAllUrl = searchUrl + '?q=' + encodeURIComponent(query) + '&type=' + encodeURIComponent(typeList.join(','));
      html += '<a href="' + viewAllUrl + '" class="predictive-results__view-all">' + escapeHtml(viewAllLabel) + '</a>';
      resultsContainer.innerHTML = html;
    }

    /*
      Curated category shortcuts. Source: window.__lp_search_suggestions, exposed
      from the theme's runtime scripts and ultimately driven by Shopify menus or
      Theme Editor settings — NOT hardcoded routes here. If nothing is configured
      we simply skip suggestions; predictive collection results still render via
      Shopify's /search/suggest.json response.
    */
    function getSearchCategorySuggestions(query) {
      var q = String(query || '').toLowerCase();
      var map = (window.__lp_search_suggestions && window.__lp_search_suggestions.length)
        ? window.__lp_search_suggestions
        : [];
      return map.filter(function (item) {
        if (!item || !item.url) return false;
        var keys = item.keys || [];
        if (!keys.length) return false;
        return keys.some(function (key) { return q.indexOf(String(key).toLowerCase()) !== -1; });
      });
    }
  }

  registerInit('initPredictiveSearch', initPredictiveSearch);
}());
